module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"Settings":"Настройки","Book":"Справочник","Editor":"Редактор геометрии","flyToLayer":"Перелететь к слою","enableRouter":"Запустить маршрутизатор","startCalc":"Запустить расчет"},"en":{"Settings":"Settings","Book":"Book","Editor":"Editor","flyToLayer":"Fly To Layer","enableRouter":"Start Router","startCalc":"Start Calculation"}}')
  delete Component.options._Ctor
}
